// extracted by mini-css-extract-plugin
export var badge = "color-badge-module--badge--qFCnp";
export var hasBorder = "color-badge-module--has-border--1xw7g";